import {requestCommon} from '../libs/axios'

export const orderLkyPay = (params) => requestCommon.post('/order/lky/order/m/pay', params) // /order/lky/order/m/pay

export const orderLkyQueryOrderStatus = (params) => requestCommon.post('//order/lky/order/m/queryOrderStatus', params) // v2订单状态查询/order/lky/order/m/queryOrderStatus

